module.exports = __webpack_public_path__ + "img/bnaV.85a39bd2.jpeg";